import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  CAlert,
  CCol,
  CForm,
  CRow,
} from '@coreui/react';
import { connect, DispatchProp } from "react-redux";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import LoadingButton from '../../shared/components/LoadingButton';
import { UserPasswordPayload } from '../../shared/models/user';
import ResetPasswordForm from '../../technicians/components/ResetPasswordForm';
import { CreateErrorNotice } from '../../store/actions/toaster.action';
import { Verify } from '../actions/verify.action';
import { ResetUserPassword } from '../../technicians/actions/userManagement.action';
import AuthUtils from '../../shared/utils/auth-utils';
import { ProfileContext } from '../../shared/contexts/profile.context';

const validationSchema = Yup.object({
  password: Yup.string().matches(/^(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/, 'Must contain 8 characters, at least 1 uppercase, 1 number').required("This field is required"),
  // eslint-disable-next-line func-names
  passwordConfirm: Yup.string().test('passwords-match', 'Passwords must match', function(value) {
    return this.parent.password === value;
  }).required("This field is required"),
});

interface ChangePasswordPageProps extends DispatchProp{
  saved: boolean;
  saving: boolean;
  verifyErrorText: string;
  changePasswordErrorText: string;
}

const ChangePasswordPage = (props: ChangePasswordPageProps) => {
  const {
    saved,
    saving,
    verifyErrorText,
    changePasswordErrorText,
    dispatch
  } = props;
  const history = useHistory();
  const { handleHideOnboarding } = useContext(ProfileContext);

  const onSubmit = (values) => {
    if (values.password && values.passwordConfirm) {
      dispatch(new ResetUserPassword({ userId: null, body: values }));
    }
  };


    useEffect(() => {
      handleHideOnboarding();
      const params = new URLSearchParams(window.location.search);

      if (!params.has('code')) {
        dispatch(new CreateErrorNotice('Error', "A verification code is required."));
        history.push('/login');
        return;
      }
      if (!AuthUtils.isAuth()) {
        dispatch(new Verify({ code: params.get('code') }));
      }
    }, []);


  const formik = useFormik({
      initialValues: {
        password: '',
        passwordConfirm: '',
      } as UserPasswordPayload,
      validationSchema,
      onSubmit,
    },
  );

  return (
    <>
      {!saved ? (
        <>
          <h1 className="text-center">Create a new password</h1>
          { !verifyErrorText ? (
            <CForm onSubmit={formik.handleSubmit}>
              <ResetPasswordForm formik={ formik } />
              {
                changePasswordErrorText && (
                  <CAlert className="my-10" color="warning" fade>
                    <div>
                      {
                        changePasswordErrorText
                      }
                    </div>
                  </CAlert>
                )
              }
              <CRow className="mb-2">
                <CCol>
                  <LoadingButton
                    type="submit"
                    className="bg-color-orange border-0 pl-4 pr-4 loginPage-loginBtn"
                    isLoading={saving}
                  >
                    Submit
                  </LoadingButton>
                </CCol>
              </CRow>
            </CForm>
          ) : (
            <>
              <CAlert className="my-10" color="warning" fade>
                <div>
                  {
                    verifyErrorText
                  }
                </div>
              </CAlert>
              <CRow>
                <CCol className="flex-column flex-center">
                  <LoadingButton
                    className="bg-color-orange border-0"
                    onClick={() => history.push('/')}
                    isLoading={false}
                  >
                    Go to Login
                  </LoadingButton>
                </CCol>
              </CRow>
            </>
          )}
        </>
      ) : (
        <>
          <CRow>
            <CCol className="flex-column flex-center">
              <h1 className="text-center">Password Reset</h1>
              <p className="text-center">Your password has been changed. Welcome back!</p>
              <LoadingButton
                className="bg-color-orange border-0"
                onClick={() => history.push('/')}
                isLoading={false}
              >
                Go to Home Page
              </LoadingButton>
            </CCol>
          </CRow>
        </>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  saved: state?.userManagement?.updateUser?.saved,
  saving: state?.userManagement?.updateUser?.saving,
  changePasswordErrorText: state?.userManagement?.updateUser?.error,
  verifyErrorText: state?.orgManagement?.verify?.errorText,

});


export default connect(mapStateToProps)(ChangePasswordPage);
